<h2 class="block text-sm font-medium text-gray-700 mt-2 mb-2">
    {{text}}
</h2>